module.exports = __webpack_public_path__ + "img/cmc.cf4292dd.png";